import i18n from '@/app/i18n'

export default {
  SET_SUCCESS_MESSAGE(
    state,
    {
      title = i18n.global.t('ToastSuccess | title'),
      message = i18n.global.t('ToastSuccess | message'),
    }
  ) {
    state.visible = true
    state.type = 'success'
    state.title = title
    state.message = message
  },

  SET_ERROR_MESSAGE(
    state,
    {
      title = i18n.global.t('ToastError | title'),
      message = i18n.global.t('ToastError | message'),
    }
  ) {
    state.visible = true
    state.type = 'error'
    state.title = title
    state.message = message
  },

  SET_INFO_MESSAGE(
    state,
    {
      title = i18n.global.t('ToastInfo | title'),
      message = i18n.global.t('ToastInfo | message'),
    }
  ) {
    state.visible = true
    state.type = 'info'
    state.title = title
    state.message = message
  },

  RESET_STORE(state) {
    state.visible = false
    state.type = null
    state.title = null
    state.message = null
  },
}
